/** MRT sorting 状态 ↔ 手机排序 Sheet 的 `field:asc|desc` 值（与域无关，供岛与各列表共用） */
export const sortingToMobileSortValue = (sorting) => {
	const first = sorting?.[0];
	if (!first?.id) {
		return 'createdAt:desc';
	}
	return `${first.id}:${first.desc ? 'desc' : 'asc'}`;
};

export const mobileSortValueToSorting = (value) => {
	const [id, dir] = String(value).split(':');
	if (!id) {
		return [{ id: 'createdAt', desc: true }];
	}
	return [{ id, desc: dir !== 'asc' }];
};
